// A referee's place in this tournament: the invitation to answer, or, once
// accepted, the other referees on the roster. Nothing for anyone else

import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Avatar from './Avatar';
import RefereeInvitation from './RefereeInvitation';
import {
  useAcceptedReferees,
  useEntities,
  useMyRefereeRates,
  useMyRefereeRoster,
} from '../utils/hooks';
import { RefereeStatuses } from '../utils/enums';
import { moneyStr } from '../utils/gameReport';
import './TournamentRefereeBlock.scss';

export default function TournamentRefereeBlock({ id }) {
  const { entries } = useMyRefereeRoster();
  const entry = entries.find((e) => e.tournamentId === id);
  const isAccepted = entry?.status === RefereeStatuses.ACCEPTED;

  const { referees } = useAcceptedReferees(id, isAccepted);
  // Accepting moved the fee into the rate; the roster entry keeps no money
  const { rates } = useMyRefereeRates(isAccepted ? id : null);
  const { entities } = useEntities(
    'users',
    referees.map((r) => r.id),
  );
  const people = useMemo(
    () =>
      entities.filter(Boolean).sort((a, b) =>
        (a.name ?? '').localeCompare(b.name ?? '', 'en', {
          sensitivity: 'base',
        }),
      ),
    [entities],
  );

  if (entry?.status === RefereeStatuses.INVITED)
    return (
      <div className='tournament-referee-block'>
        <RefereeInvitation entry={entry} />
      </div>
    );

  if (!isAccepted) return null;

  return (
    <div className='tournament-referee-block'>
      <p>
        You're on the referee roster
        {rates?.rate !== undefined && (
          <>
            , <span className='font-medium'>{moneyStr(rates.rate)}</span> per
            game
          </>
        )}
      </p>
      <ul className='roster'>
        {people.map((person) => (
          <li key={person.id}>
            <Link to={`/referees/${person.id}`} className='person'>
              <Avatar user={person} size={32} />
              <span>{person.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
